<template>
  <v-container grid-list-sm>
    <v-toolbar>
      <v-toolbar-title>Amaala Weekly Report</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-text-field label="From Date" style="margin: 5px;" v-model="fromDate"></v-text-field>
        <v-text-field label="To Date" style="margin: 5px;" v-model="toDate"></v-text-field>
        <v-btn flat @click="generateReport" :loading="loading">Generate Report</v-btn>
        <v-btn flat @click="exportPptx" :disabled="loading || !reportExists" :loading="exportLoading">Export PPTX</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <br/>
    <h2>AMAALA STORIES</h2>
    <span id="amaalaStoriesJSONView" ref="amaalaStoriesJSONView"></span>

    <br/>
    <h2>AMAALA ARTICLES</h2>
    <span id="amaalaArticlesJSONView" ref="amaalaArticlesJSONView"></span>

    <br/>
    <h2>AMAALA FOLLOWERS</h2>
    <span id="amaalaFollowersJSONView" ref="amaalaFollowersJSONView"></span>

    <br/>
    <h2>AMAALA TWEETS</h2>
    <span id="amaalaTweetsJSONView" ref="amaalaTweetsJSONView"></span>

    <br/>
    <h2>NEOM STORIES</h2>
    <span id="neomStoriesJSONView" ref="neomStoriesJSONView"></span>

    <br/>
    <h2>NEOM ARTICLES</h2>
    <span id="neomArticlesJSONView" ref="neomArticlesJSONView"></span>

    <br/>
    <h2>NEOM TWEETS</h2>
    <span id="neomTweetsJSONView" ref="neomTweetsJSONView"></span>

    <br/>
    <h2>QIDDIYA STORIES</h2>
    <span id="qiddiyaStoriesJSONView" ref="qiddiyaStoriesJSONView"></span>

    <br/>
    <h2>QIDDIYA ARTICLES</h2>
    <span id="qiddiyaArticlesJSONView" ref="qiddiyaArticlesJSONView"></span>

    <br/>
    <h2>QIDDIYA TWEETS</h2>
    <span id="qiddiyaTweetsJSONView" ref="qiddiyaTweetsJSONView"></span>

    <br/>
    <h2>RED SEA STORIES</h2>
    <span id="redSeaStoriesJSONView" ref="redSeaStoriesJSONView"></span>

    <br/>
    <h2>RED SEA ARTICLES</h2>
    <span id="redSeaArticlesJSONView" ref="redSeaArticlesJSONView"></span>

    <br/>
    <h2>RED SEA TWEETS</h2>
    <span id="redSeaTweetsJSONView" ref="redSeaTweetsJSONView"></span>
  </v-container>
</template>

<script>
import PptxGenJS from 'pptxgenjs'
import { mapMutations } from 'vuex'
import { getUTCDate } from '@/helpers/formatters'
import numeral from 'numeral'

export default {
  data () {
    return {
      loading: false,
      exportLoading: false,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      amaalaStories: [],
      amaalaArticles: [],
      amaalaCounters: {},
      amaalaTweets: [],
      amaalaTwitterUsers: [],
      amaalaFollowers: [],
      wiwStories: [],
      wiwArticles: [],
      wiwCounters: {},
      wiwTweets: [],
      wiwTwitterUsers: [],
      wiwFollowers: [],
      neomStories: [],
      neomArticles: [],
      neomCounters: {},
      neomTweets: [],
      neomTwitterUsers: [],
      neomFollowers: [],
      redSeaStories: [],
      redSeaArticles: [],
      redSeaCounters: {},
      redSeaTweets: [],
      redSeaTwitterUsers: [],
      redSeaFollowers: [],
      qiddiyaStories: [],
      qiddiyaArticles: [],
      qiddiyaCounters: {},
      qiddiyaTweets: [],
      qiddiyaTwitterUsers: [],
      qiddiyaFollowers: [],
      previousDate: '',
      fromDate: '',
      toDate: '',
      slide: null,
      pptx: null,
      slideLines: 0,
      reportExists: false
    }
  },
  created () {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth()
    var today = date.getDate()
    var oneweekago = this.addDays(date, -6)
    var oneweekandoneago = this.addDays(date, -7)
    this.toDate = year + '-' + ((month + 1) < 10 ? '0' + (month + 1) : (month + 1)) + '-' + today + ' 08:00:00'
    this.fromDate = oneweekago.getFullYear() + '-' + ((oneweekago.getMonth() + 1) < 10 ? '0' + (oneweekago.getMonth() + 1) : (oneweekago.getMonth() + 1)) + '-' + oneweekago.getDate() + ' 08:00:00'
    this.previousDate = oneweekandoneago.getFullYear() + '-' + ((oneweekandoneago.getMonth() + 1) < 10 ? '0' + (oneweekandoneago.getMonth() + 1) : (oneweekandoneago.getMonth() + 1)) + '-' + oneweekandoneago.getDate() + ' 08:00:00'
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('loading', ['showLoading', 'hideLoading']),
    addDays: function (date, days) {
      var result = new Date(date)
      result.setDate(result.getDate() + days)
      return result
    },
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    clear: function () {
      this.amaalaStories = []
      this.amaalaArticles = []
      this.amaalaCounters = {}
      this.amaalaTweets = []
      this.amaalaTwitterUsers = []
      this.amaalaFollowers = []
      this.wiwStories = []
      this.wiwArticles = []
      this.wiwCounters = {}
      this.wiwTweets = []
      this.wiwTwitterUsers = []
      this.wiwFollowers = []
      this.neomStories = []
      this.neomArticles = []
      this.neomCounters = {}
      this.neomTweets = []
      this.neomTwitterUsers = []
      this.neomFollowers = []
      this.redSeaStories = []
      this.redSeaArticles = []
      this.redSeaCounters = {}
      this.redSeaTweets = []
      this.redSeaTwitterUsers = []
      this.redSeaFollowers = []
      this.qiddiyaStories = []
      this.qiddiyaArticles = []
      this.qiddiyaCounters = {}
      this.qiddiyaTweets = []
      this.qiddiyaTwitterUsers = []
      this.qiddiyaFollowers = []
    },
    async generateReport () {
      this.loading = true
      this.reportExists = false
      this.clear()
      this.fromDate = this.fromDate.trim()
      this.toDate = this.toDate.trim()
      var date = new Date(this.fromDate)
      var daybefore = this.addDays(date, -1)
      this.previousDate = daybefore.getFullYear() + '-' + ((daybefore.getMonth() + 1) < 10 ? '0' + (daybefore.getMonth() + 1) : (daybefore.getMonth() + 1)) + '-' + daybefore.getDate() + ' 08:00:00'

      window.renderjson.set_icons('+', '-')
      window.renderjson.set_show_to_level(1)

      this.amaalaStories = await this.getStories('d7fb1573-2ebb-4028-a2b8-1bd494e312f5')
      this.amaalaArticles = await this.getArticles('d7fb1573-2ebb-4028-a2b8-1bd494e312f5')
      this.amaalaCounters = await this.getCounters('d7fb1573-2ebb-4028-a2b8-1bd494e312f5')
      this.amaalaTweets = await this.getTweets('d7fb1573-2ebb-4028-a2b8-1bd494e312f5')
      this.amaalaTwitterUsers = await this.getTwitterUsers('d7fb1573-2ebb-4028-a2b8-1bd494e312f5')
      this.amaalaFollowers = await this.getFollowers('d7fb1573-2ebb-4028-a2b8-1bd494e312f5', 'WelcomeToAmaala', 'day', this.previousDate, this.toDate)

      this.neomStories = await this.getStories('b4b9e913-c14a-4e5e-97a7-fda2175df7f0')
      this.neomArticles = await this.getArticles('b4b9e913-c14a-4e5e-97a7-fda2175df7f0')
      this.neomCounters = await this.getCounters('b4b9e913-c14a-4e5e-97a7-fda2175df7f0')
      this.neomTweets = await this.getTweets('b4b9e913-c14a-4e5e-97a7-fda2175df7f0')
      this.neomTwitterUsers = await this.getTwitterUsers('b4b9e913-c14a-4e5e-97a7-fda2175df7f0')
      this.neomFollowers = await this.getFollowers('b4b9e913-c14a-4e5e-97a7-fda2175df7f0', 'NEOM', 'day', this.previousDate, this.toDate)

      this.qiddiyaStories = await this.getStories('eb314de9-003a-47a1-bede-b2df0dc9d82e')
      this.qiddiyaArticles = await this.getArticles('eb314de9-003a-47a1-bede-b2df0dc9d82e')
      this.qiddiyaCounters = await this.getCounters('eb314de9-003a-47a1-bede-b2df0dc9d82e')
      this.qiddiyaTweets = await this.getTweets('eb314de9-003a-47a1-bede-b2df0dc9d82e')
      this.qiddiyaTwitterUsers = await this.getTwitterUsers('eb314de9-003a-47a1-bede-b2df0dc9d82e')
      this.qiddiyaFollowers = await this.getFollowers('eb314de9-003a-47a1-bede-b2df0dc9d82e', 'qiddiya', 'day', this.previousDate, this.toDate)

      this.redSeaStories = await this.getStories('2f46453a-160d-45bf-a155-993603c516fb')
      this.redSeaArticles = await this.getArticles('2f46453a-160d-45bf-a155-993603c516fb')
      this.redSeaCounters = await this.getCounters('2f46453a-160d-45bf-a155-993603c516fb')
      this.redSeaTweets = await this.getTweets('2f46453a-160d-45bf-a155-993603c516fb')
      this.redSeaTwitterUsers = await this.getTwitterUsers('2f46453a-160d-45bf-a155-993603c516fb')
      this.redSeaFollowers = await this.getFollowers('2f46453a-160d-45bf-a155-993603c516fb', 'TheRedSeaSA', 'day', this.previousDate, this.toDate)

      this.wiwStories = await this.getStories('702257fe-e952-483b-831b-af3497bab246')
      this.wiwArticles = await this.getArticles('702257fe-e952-483b-831b-af3497bab246')
      this.wiwCounters = await this.getCounters('702257fe-e952-483b-831b-af3497bab246')
      this.wiwTweets = await this.getTweets('702257fe-e952-483b-831b-af3497bab246')
      this.wiwTwitterUsers = await this.getTwitterUsers('702257fe-e952-483b-831b-af3497bab246')

      document.getElementById('amaalaStoriesJSONView').innerHTML = ''
      document.getElementById('amaalaArticlesJSONView').innerHTML = ''
      document.getElementById('amaalaTweetsJSONView').innerHTML = ''
      document.getElementById('amaalaFollowersJSONView').innerHTML = ''
      document.getElementById('neomStoriesJSONView').innerHTML = ''
      document.getElementById('neomArticlesJSONView').innerHTML = ''
      document.getElementById('neomTweetsJSONView').innerHTML = ''
      document.getElementById('qiddiyaStoriesJSONView').innerHTML = ''
      document.getElementById('qiddiyaArticlesJSONView').innerHTML = ''
      document.getElementById('qiddiyaTweetsJSONView').innerHTML = ''
      document.getElementById('redSeaStoriesJSONView').innerHTML = ''
      document.getElementById('redSeaArticlesJSONView').innerHTML = ''
      document.getElementById('redSeaTweetsJSONView').innerHTML = ''

      document.getElementById('amaalaStoriesJSONView').appendChild(window.renderjson({ stories: this.amaalaStories }))
      document.getElementById('amaalaArticlesJSONView').appendChild(window.renderjson({ articles: this.amaalaArticles }))
      document.getElementById('amaalaTweetsJSONView').appendChild(window.renderjson({ tweets: this.amaalaTweets }))
      document.getElementById('amaalaFollowersJSONView').appendChild(window.renderjson({ tweets: this.amaalaFollowers }))
      document.getElementById('neomStoriesJSONView').appendChild(window.renderjson({ stories: this.neomStories }))
      document.getElementById('neomArticlesJSONView').appendChild(window.renderjson({ article: this.neomArticles }))
      document.getElementById('neomTweetsJSONView').appendChild(window.renderjson({ tweets: this.neomTweets }))
      document.getElementById('qiddiyaStoriesJSONView').appendChild(window.renderjson({ stories: this.qiddiyaStories }))
      document.getElementById('qiddiyaArticlesJSONView').appendChild(window.renderjson({ articles: this.qiddiyaArticles }))
      document.getElementById('qiddiyaTweetsJSONView').appendChild(window.renderjson({ tweets: this.qiddiyaTweets }))
      document.getElementById('redSeaStoriesJSONView').appendChild(window.renderjson({ stories: this.redSeaStories }))
      document.getElementById('redSeaArticlesJSONView').appendChild(window.renderjson({ article: this.redSeaArticles }))
      document.getElementById('redSeaTweetsJSONView').appendChild(window.renderjson({ tweets: this.redSeaTweets }))

      this.loading = false
      this.reportExists = true
    },
    async getStories (projectUuid) {
      try {
        let i = 0
        let j = 0
        let results = []

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_tweet_count'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsStories', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_article_count'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        response = await this.$store.dispatch('getCustomReportsStories', query)
        if (response.data.status === 'SUCCESS') {
          for (i = 0; i < response.data.payload.length; i++) {
            var found = false
            for (j = 0; j < results.length; j++) {
              if (Number(results[j].id) === Number(response.data.payload[i].id)) {
                found = true
                break
              }
            }
            if (found === false) {
              results.push(response.data.payload[i])
            }
          }
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_facebook_shares'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        response = await this.$store.dispatch('getCustomReportsStories', query)
        if (response.data.status === 'SUCCESS') {
          for (i = 0; i < response.data.payload.length; i++) {
            found = false
            for (j = 0; j < results.length; j++) {
              if (Number(results[j].id) === Number(response.data.payload[i].id)) {
                found = true
                break
              }
            }
            if (found === false) {
              results.push(response.data.payload[i])
            }
          }
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    async getArticles (projectUuid) {
      try {
        let results = []

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_tweeted_count'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsArticlesWithoutStories', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    async getCounters (projectUuid) {
      try {
        let results = {}

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        let response = await this.$store.dispatch('getCustomReportsTweetsCount', query)
        if (response.data.status === 'SUCCESS') {
          results._tweet_count = response.data.payload[0]._tweet_count
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsImpressionsCount', query)
        if (response.data.status === 'SUCCESS') {
          results._impression_count = response.data.payload[0]._impression_count
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate.split(' ')[0] + ' 00:00:00')
        query += '&toDate=' + getUTCDate(this.toDate.split(' ')[0] + ' 23:59:59')
        query += '&interval=' + 'hour'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsVolume', query)
        if (response.data.status === 'SUCCESS') {
          results._tweets_volume = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate.split(' ')[0] + ' 00:00:00')
        query += '&toDate=' + getUTCDate(this.toDate.split(' ')[0] + ' 23:59:59')
        query += '&interval=' + 'hour'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsImpressionsVolume', query)
        if (response.data.status === 'SUCCESS') {
          results._impressions_volume = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsTypesCount', query)
        if (response.data.status === 'SUCCESS') {
          results._tweets_types = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTwitterUsersCount', query)
        if (response.data.status === 'SUCCESS') {
          results._user_count = response.data.payload[0]._user_count
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsArticlesCount', query)
        if (response.data.status === 'SUCCESS') {
          results._article_count = response.data.payload[0]._article_count
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsStoriesStats', query)
        if (response.data.status === 'SUCCESS') {
          results._stories_stats = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsCountBySentiment', query)
        if (response.data.status === 'SUCCESS') {
          results._twitter_sentiment = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&pageSize=' + '200'
        query += '&pageNumber=' + '1'
        query += '&sortBy=' + '_tweet_count'
        query += '&order=' + 'desc'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsCountByCountry', query)
        if (response.data.status === 'SUCCESS') {
          results._twitter_countries = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&pageSize=' + '10'
        query += '&pageNumber=' + '1'
        query += '&sortBy=' + '_tweet_count'
        query += '&order=' + 'desc'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTwitterHashtags', query)
        if (response.data.status === 'SUCCESS') {
          results._twitter_hashtags = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsArticlesCountBySentiment', query)
        if (response.data.status === 'SUCCESS') {
          results._news_sentiment = response.data.payload
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return {}
      }
    },
    async getTweets (projectUuid) {
      try {
        let i = 0
        let j = 0
        let results = []

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_twitter_interactions_latest'
        query += '&tweetType=' + 'TWEET'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '10'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsTweets', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_twitter_interactions_latest'
        query += '&tweetType=' + 'RETWEET'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        response = await this.$store.dispatch('getCustomReportsTweets', query)
        if (response.data.status === 'SUCCESS') {
          for (i = 0; i < response.data.payload.length; i++) {
            var found = false
            for (j = 0; j < results.length; j++) {
              if (Number(results[j]._tweet_id) === Number(response.data.payload[i]._tweet_id)) {
                found = true
                break
              }
            }
            if (found === false) {
              results.push(response.data.payload[i])
            }
          }
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_twitter_interactions_latest'
        query += '&tweetType=' + 'QUOTE_TWEET'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        response = await this.$store.dispatch('getCustomReportsTweets', query)
        if (response.data.status === 'SUCCESS') {
          for (i = 0; i < response.data.payload.length; i++) {
            found = false
            for (j = 0; j < results.length; j++) {
              if (Number(results[j]._tweet_id) === Number(response.data.payload[i]._tweet_id)) {
                found = true
                break
              }
            }
            if (found === false) {
              results.push(response.data.payload[i])
            }
          }
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_twitter_interactions_latest'
        query += '&tweetType=' + 'REPLY_TWEET'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        response = await this.$store.dispatch('getCustomReportsTweets', query)
        if (response.data.status === 'SUCCESS') {
          for (i = 0; i < response.data.payload.length; i++) {
            found = false
            for (j = 0; j < results.length; j++) {
              if (Number(results[j]._tweet_id) === Number(response.data.payload[i]._tweet_id)) {
                found = true
                break
              }
            }
            if (found === false) {
              results.push(response.data.payload[i])
            }
          }
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    async getTwitterUsers (projectUuid) {
      try {
        let results = []

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_followers_count'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '10'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsTwitterUsers', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    async getFollowers (projectUuid, handle, interval, from, to) {
      try {
        let results = []

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(from)
        query += '&toDate=' + getUTCDate(to)
        query += '&interval=' + interval
        query += '&screenName=' + handle
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsTwitterUserEvolution', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    generateSourcesPieChart: function (slide, dataSource) {
      var data = [
        {
          name: 'Sources of Mentions',
          labels: ['News', 'Twitter'],
          values: [Number(dataSource._article_count), Number(dataSource._tweet_count)]
        }
      ]

      var options = {
        x: -0.13,
        y: 7.75,
        w: 2.7,
        h: 2.35,
        dataBorder: { pt: '2', color: 'F1F1F1' },
        dataLabelColor: '000000',
        dataLabelFontSize: 7,
        showLabel: true,
        showValue: true,
        showPercent: true,
        showLegend: false,
        showTitle: false,
        title: 'Sources of Mentions'
      }

      slide.addChart(this.pptx.charts.DOUGHNUT, data, options)
    },
    generateGeoTable: function (slide, dataSource) {
      var total = 0
      for (var i = 0; i < dataSource._twitter_countries.length; i++) {
        total += Number(dataSource._twitter_countries[i]._tweet_count)
      }

      var rows = [
        [{text: 'Country', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: 'Share of\nMentions', options: {valign: 'c', align: 'c', fontFace: 'Arial'}}],
        [{text: dataSource._twitter_countries[0] ? dataSource._twitter_countries[0]._country_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_countries[0] ? ((dataSource._twitter_countries[0]._tweet_count / total) * 100).toFixed(2) + '%' : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_countries[1] ? dataSource._twitter_countries[1]._country_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_countries[1] ? ((dataSource._twitter_countries[1]._tweet_count / total) * 100).toFixed(2) + '%' : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_countries[2] ? dataSource._twitter_countries[2]._country_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_countries[2] ? ((dataSource._twitter_countries[2]._tweet_count / total) * 100).toFixed(2) + '%' : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_countries[3] ? dataSource._twitter_countries[3]._country_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_countries[3] ? ((dataSource._twitter_countries[3]._tweet_count / total) * 100).toFixed(2) + '%' : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_countries[4] ? dataSource._twitter_countries[4]._country_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_countries[4] ? ((dataSource._twitter_countries[4]._tweet_count / total) * 100).toFixed(2) + '%' : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}]
      ]

      var tabOpts = {x: 2.38, y: 8.12, w: 1.93, rowH: 0.3, fill: 'FFFFFF', fontSize: 9, color: '000000', valign: 'm', border: {pt: '1', color: '000000'}}
      slide.addTable(rows, tabOpts)
    },
    generateWordCloudTable: function (slide, dataSource) {
      var rows = [
        [{text: 'Keyword', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: 'Posts', options: {valign: 'c', align: 'c', fontFace: 'Arial'}}],
        [{text: dataSource._twitter_hashtags[0] ? '#' + dataSource._twitter_hashtags[0]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[0] ? this.formatNumber(dataSource._twitter_hashtags[0]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_hashtags[1] ? '#' + dataSource._twitter_hashtags[1]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[1] ? this.formatNumber(dataSource._twitter_hashtags[1]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_hashtags[2] ? '#' + dataSource._twitter_hashtags[2]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[2] ? this.formatNumber(dataSource._twitter_hashtags[2]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_hashtags[3] ? '#' + dataSource._twitter_hashtags[3]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[3] ? this.formatNumber(dataSource._twitter_hashtags[3]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_hashtags[4] ? '#' + dataSource._twitter_hashtags[4]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[4] ? this.formatNumber(dataSource._twitter_hashtags[4]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}]
      ]

      var tabOpts = {x: 4.89, y: 8.12, w: 1.93, rowH: 0.3, fill: 'FFFFFF', fontSize: 9, color: '000000', valign: 'm', border: {pt: '1', color: '000000'}}
      slide.addTable(rows, tabOpts)
    },
    generateHashtagsTable: function (slide, dataSource) {
      var rows = [
        [{text: '#Hashtag', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: 'Posts', options: {valign: 'c', align: 'c', fontFace: 'Arial'}}],
        [{text: dataSource._twitter_hashtags[0] ? '#' + dataSource._twitter_hashtags[0]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[0] ? this.formatNumber(dataSource._twitter_hashtags[0]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_hashtags[1] ? '#' + dataSource._twitter_hashtags[1]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[1] ? this.formatNumber(dataSource._twitter_hashtags[1]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_hashtags[2] ? '#' + dataSource._twitter_hashtags[2]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[2] ? this.formatNumber(dataSource._twitter_hashtags[2]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_hashtags[3] ? '#' + dataSource._twitter_hashtags[3]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[3] ? this.formatNumber(dataSource._twitter_hashtags[3]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource._twitter_hashtags[4] ? '#' + dataSource._twitter_hashtags[4]._tag : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource._twitter_hashtags[4] ? this.formatNumber(dataSource._twitter_hashtags[4]._tweet_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}]
      ]

      var tabOpts = {x: 6.98, y: 8.12, w: 1.93, rowH: 0.3, fill: 'FFFFFF', fontSize: 9, color: '000000', valign: 'm', border: {pt: '1', color: '000000'}}
      slide.addTable(rows, tabOpts)
    },
    generateTwoAxisChart: function (slide, dataSource) {
      this.fromDate = this.fromDate.trim()
      this.toDate = this.toDate.trim()
      var fromDay = new Date(this.fromDate).getDate()
      var fromDayString = fromDay < 10 ? '0' + fromDay + '' : fromDay + ''
      var fromMonth = new Date(this.fromDate).getMonth() + 1
      var fromMonthString = fromMonth < 10 ? '0' + fromMonth + '' : fromMonth + ''
      var fromYear = new Date(this.fromDate).getFullYear()
      var toDay = new Date(this.toDate).getDate()
      var toDayString = toDay < 10 ? '0' + toDay + '' : toDay + ''
      var toMonth = new Date(this.toDate).getMonth() + 1
      var toMonthString = toMonth < 10 ? '0' + toMonth + '' : toMonth + ''
      var toYear = new Date(this.toDate).getFullYear()
      var reportTimePoints = {}
      var reportDaysStart = fromYear + '-' + fromMonthString + '-' + fromDayString
      var reportDaysEnd = toYear + '-' + toMonthString + '-' + toDayString
      var i = 0
      var count = 0

      // add all the data points initially set to zero
      while (reportDaysStart !== reportDaysEnd && count <= 7) {
        for (i = 0; i < 24; i++) {
          reportTimePoints[(reportDaysStart + ' ' + (i < 10 ? '0' + i : i) + ':00:00')] = {_tweet_count: 0, _impression_count: 0}
        }
        var temp = new Date(this.fromDate)
        temp = this.addDays(temp, count + 1)
        var tempDay = temp.getDate()
        var tempDayString = tempDay < 10 ? '0' + tempDay + '' : tempDay + ''
        var tempMonth = temp.getMonth() + 1
        var tempMonthString = tempMonth < 10 ? '0' + tempMonth + '' : tempMonth + ''
        reportDaysStart = temp.getFullYear() + '-' + tempMonthString + '-' + tempDayString
        count++
      }
      for (i = 0; i < 24; i++) {
        reportTimePoints[(reportDaysEnd + ' ' + (i < 10 ? '0' + i : i) + ':00:00')] = {_tweet_count: 0, _impression_count: 0}
      }

      // now fill the data
      for (i = 0; i < dataSource._tweets_volume.length; i++) {
        var tweetsTempYear = dataSource._tweets_volume[i]._created_at_year
        var tweetsTempMonth = (dataSource._tweets_volume[i]._created_at_month < 10 ? '0' + dataSource._tweets_volume[i]._created_at_month : dataSource._tweets_volume[i]._created_at_month)
        var tweetsTempDay = (dataSource._tweets_volume[i]._created_at_day < 10 ? '0' + dataSource._tweets_volume[i]._created_at_day : dataSource._tweets_volume[i]._created_at_day)
        var tweetsTempTime = (dataSource._tweets_volume[i]._created_at_hour < 10 ? '0' + dataSource._tweets_volume[i]._created_at_hour : dataSource._tweets_volume[i]._created_at_hour) + ':00:00'
        var tweetsTempUTCDate = new Date(tweetsTempMonth + '/' + tweetsTempDay + '/' + tweetsTempYear + ' ' + tweetsTempTime + ' UTC')
        var tweetsLocalDay = tweetsTempUTCDate.getDate()
        var tweetsLocalDayString = tweetsLocalDay < 10 ? '0' + tweetsLocalDay + '' : tweetsLocalDay + ''
        var tweetsLocalMonth = tweetsTempUTCDate.getMonth() + 1
        var tweetsLocalMonthString = tweetsLocalMonth < 10 ? '0' + tweetsLocalMonth + '' : tweetsLocalMonth + ''
        var tweetsLocalYear = tweetsTempUTCDate.getFullYear()
        var tweetsLocalHour = tweetsTempUTCDate.getHours()
        var tweetsLocalHourString = tweetsLocalHour < 10 ? '0' + tweetsLocalHour + '' : tweetsLocalHour + ''
        reportTimePoints[(tweetsLocalYear + '-' + tweetsLocalMonthString + '-' + tweetsLocalDayString + ' ' + tweetsLocalHourString + ':00:00')]._tweet_count = dataSource._tweets_volume[i]._tweet_count
      }

      for (i = 0; i < dataSource._impressions_volume.length; i++) {
        var impsTempYear = dataSource._tweets_volume[i]._created_at_year
        var impsTempMonth = (dataSource._tweets_volume[i]._created_at_month < 10 ? '0' + dataSource._impressions_volume[i]._created_at_month : dataSource._impressions_volume[i]._created_at_month)
        var impsTempDay = (dataSource._tweets_volume[i]._created_at_day < 10 ? '0' + dataSource._impressions_volume[i]._created_at_day : dataSource._impressions_volume[i]._created_at_day)
        var impsTempTime = (dataSource._tweets_volume[i]._created_at_hour < 10 ? '0' + dataSource._impressions_volume[i]._created_at_hour : dataSource._impressions_volume[i]._created_at_hour) + ':00:00'
        var impsTempUTCDate = new Date(impsTempMonth + '/' + impsTempDay + '/' + impsTempYear + ' ' + impsTempTime + ' UTC')
        var impsLocalDay = impsTempUTCDate.getDate()
        var impsLocalDayString = impsLocalDay < 10 ? '0' + impsLocalDay + '' : impsLocalDay + ''
        var impsLocalMonth = impsTempUTCDate.getMonth() + 1
        var impsLocalMonthString = impsLocalMonth < 10 ? '0' + impsLocalMonth + '' : impsLocalMonth + ''
        var impsLocalYear = impsTempUTCDate.getFullYear()
        var impsLocalHour = impsTempUTCDate.getHours()
        var impsLocalHourString = impsLocalHour < 10 ? '0' + impsLocalHour + '' : impsLocalHour + ''
        reportTimePoints[(impsLocalYear + '-' + impsLocalMonthString + '-' + impsLocalDayString + ' ' + impsLocalHourString + ':00:00')]._impression_count = dataSource._impressions_volume[i]._impression_count
      }

      var labels = []
      var tweetsData = []
      var impressionsData = []

      reportDaysStart = fromYear + '-' + fromMonthString + '-' + fromDayString
      reportDaysEnd = toYear + '-' + toMonthString + '-' + toDayString
      i = 0
      count = 0

      // add all the data points initially set to zero
      while (reportDaysStart !== reportDaysEnd && count <= 7) {
        for (i = 0; i < 24; i += 8) {
          if (i === 0) {
            labels.push(this.months[Number(reportDaysStart.split('-')[1]) - 1] + ' ' + reportDaysStart.split('-')[2])
          } else {
            labels.push((i < 10 ? '0' + i : i) + ':00')
          }
          tweetsData.push(reportTimePoints[(reportDaysStart + ' ' + (i < 10 ? '0' + i : i) + ':00:00')]._tweet_count)
          impressionsData.push(reportTimePoints[(reportDaysStart + ' ' + (i < 10 ? '0' + i : i) + ':00:00')]._impression_count)
        }
        temp = new Date(this.fromDate)
        temp = this.addDays(temp, count + 1)
        tempDay = temp.getDate()
        tempDayString = tempDay < 10 ? '0' + tempDay + '' : tempDay + ''
        tempMonth = temp.getMonth() + 1
        tempMonthString = tempMonth < 10 ? '0' + tempMonth + '' : tempMonth + ''
        reportDaysStart = temp.getFullYear() + '-' + tempMonthString + '-' + tempDayString
        count++
      }
      for (i = 0; i < 24; i += 8) {
        if (i === 0) {
          labels.push(this.months[Number(reportDaysStart.split('-')[1]) - 1] + ' ' + reportDaysStart.split('-')[2])
        } else {
          labels.push((i < 10 ? '0' + i : i) + ':00')
        }
        tweetsData.push(reportTimePoints[(reportDaysStart + ' ' + (i < 10 ? '0' + i : i) + ':00:00')]._tweet_count)
        impressionsData.push(reportTimePoints[(reportDaysStart + ' ' + (i < 10 ? '0' + i : i) + ':00:00')]._impression_count)
      }

      var opts = {
        x: 0.17,
        y: 4.6,
        w: '98%',
        h: 2.0,
        catAxisLabelColor: '000000',
        catAxisLabelFontFace: 'Proxima Nova',
        catAxisLabelFontSize: 5,
        catAxisOrientation: 'minMax',
        showLegend: true,
        legendPos: 'b',
        legendFontSize: 5,
        showTitle: false,
        lineSmooth: true,
        valAxisMinVal: 0,
        valAxes: [
          {showValAxisTitle: true, valAxisTitle: 'Mentions'},
          {showValAxisTitle: true, valAxisTitle: 'Potential Impressions', valGridLine: 'none'}
        ],
        catAxes: [
          {catAxisTitle: 'Primary Category Axis'},
          {catAxisHidden: true}
        ]
      }
      var chartTypes = [
        {
          type: this.pptx.charts.AREA,
          data: [{name: 'Potential Impressions', labels: labels, values: impressionsData}],
          options: {chartColors: ['00FFFF'], barGrouping: 'standard', secondaryValAxis: !!opts.valAxes, secondaryCatAxis: !!opts.catAxes}
        },
        {
          type: this.pptx.charts.LINE,
          data: [{name: 'Mentions', labels: labels, values: tweetsData}],
          options: {barGrouping: 'standard'}
        }
      ]
      slide.addChart(chartTypes, opts)
    },
    generateTwitterUsersTable: function (slide, dataSource) {
      var rows = [
        [{text: 'Screen Name', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: 'Followers', options: {valign: 'c', align: 'c', fontFace: 'Arial'}}],
        [{text: dataSource[0] ? dataSource[0]._screen_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource[0] ? this.formatNumber(dataSource[0]._followers_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource[1] ? dataSource[1]._screen_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource[1] ? this.formatNumber(dataSource[1]._followers_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource[2] ? dataSource[2]._screen_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource[2] ? this.formatNumber(dataSource[2]._followers_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource[3] ? dataSource[3]._screen_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource[3] ? this.formatNumber(dataSource[3]._followers_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}],
        [{text: dataSource[4] ? dataSource[4]._screen_name : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}},
        {text: dataSource[4] ? this.formatNumber(dataSource[4]._followers_count) : '', options: {valign: 'c', align: 'c', fontFace: 'Proxima Nova'}}]
      ]

      var tabOpts = {x: 0.47, y: 11.14, w: 8.20, rowH: 0.2, fill: 'FFFFFF', fontSize: 9, color: '000000', valign: 'm', border: {pt: '1', color: '000000'}}
      slide.addTable(rows, tabOpts)
    },
    exportPptx: function () {
      this.exportLoading = true

      this.pptx = new PptxGenJS()
      this.pptx.setLayout({ name: 'A4', width: 9, height: 14 })
      this.fromDate = this.fromDate.trim()
      this.toDate = this.toDate.trim()
      var from = new Date(this.fromDate).getDate()
      var fromMonth = new Date(this.fromDate).getMonth()
      var to = new Date(this.toDate).getDate()
      var toMonth = new Date(this.toDate).getMonth()
      var toYear = new Date(this.toDate).getFullYear()
      var slideNumber = 2

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_COVER',
        bkgd: 'FFFFFF',
        objects: [
          { 'text': { text: 'AMAALA\nWeekly Listening and Monitoring\n' + '(' + this.months[fromMonth] + ' ' + from + ' - ' + this.months[toMonth] + ' ' + to + ', ' + toYear + ')', options: { x: 0.76, y: 3.16, w: 6.72, h: 1.92, color: '000000', bold: true, fontFace: 'Libre Baskerville', fontSize: 27 } } },
          { 'image': { x: 0.72, y: 5.49, w: 7.55, h: 2.76, path: '/static/amaala-background.png' } }
        ]
      })

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_MENU',
        bkgd: 'FFFFFF',
        objects: [
          { 'rect': { x: 0.0, y: 0, w: '100%', h: 0.83, fill: 'efefef' } },
          { 'image': { x: 2.62, y: 1.02, w: 3.77, h: 2.73, path: '/static/amaala-logo.png' } },
          { 'text': { text: 'REPORT INDEX', options: { align: 'center', x: -0.01, y: 0, w: 9.01, h: 0.83, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: '1.  Executive Summary', options: { x: 0.80, y: 5, w: 7.5, h: 1, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: '2.  Category News', options: { x: 0.80, y: 5.5, w: 7.5, h: 1, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: '3.  Category Overview on Social Media', options: { x: 0.80, y: 6.0, w: 7.5, h: 1, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: '4.  AMAALA\'s Owned Content', options: { x: 0.80, y: 6.5, w: 7.5, h: 1, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: '5.  AMMAALA Overview', options: { x: 0.80, y: 7.0, w: 7.5, h: 1, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: '6.  NEOM Overview', options: { x: 0.80, y: 7.5, w: 7.5, h: 1, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: '7.  Qiddiya Overview', options: { x: 0.80, y: 8.0, w: 7.5, h: 1, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: '8.  The Red Sea Project Overview', options: { x: 0.80, y: 8.5, w: 7.5, h: 1, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'image': { x: 0.28, y: 13.37, w: 0.63, h: 0.35, path: '/static/mirum-logo.png' } },
          { 'image': { x: 1.04, y: 13.49, w: 1.27, h: 0.19, path: '/static/hks-logo.png' } },
          { 'text': { text: 'Strictly Confidential   |   ' + slideNumber++, options: { align: 'left', x: 7.50, y: 13.22, w: 2, h: 0.39, color: '666666', bold: false, fontFace: 'Proxima Nova', fontSize: 7, valign: 'middle' } } }
        ]
      })

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_AMAALA_OVERVIEW',
        bkgd: 'FFFFFF',
        objects: [
          { 'rect': { x: 0.0, y: 0, w: '100%', h: 0.83, fill: 'efefef' } },
          { 'image': { x: 0.02, y: 0.0, w: 0.71, h: 0.5, path: '/static/amaala-small.png' } },
          { 'text': { text: 'AMAALA\'S CONVERSATION', options: { valign: 'center', align: 'center', x: -0.01, y: 0, w: 9.5, h: 0.83, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: this.months[fromMonth] + ' ' + from + ' - ' + this.months[toMonth] + ' ' + to + '\n' + toYear, options: { valign: 'center', align: 'center', x: 7.58, y: 0.0, w: 1.4, h: 0.5, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 0.28, y: 0.71, w: 8.49, h: 0.62, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'rect': { x: 3.74, y: 1.76, w: 1.7, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Summary Metrics', options: { valign: 'center', align: 'center', x: 3.74, y: 1.76, w: 1.7, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.amaalaCounters._tweet_count) + '\nMentions', options: { valign: 'center', align: 'center', x: 2.16, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.amaalaCounters._impression_count) + '\nPotential Impressions', options: { valign: 'center', align: 'center', x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 2 * 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.amaalaCounters._user_count) + '\nAuthors', options: { valign: 'center', align: 'center', x: 2.16 + 2 * 1.65, y: 2.48, w: 1.5, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 3.16, y: 3.51, w: 2.87, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Timeline of Mentions and Impressions', options: { valign: 'center', align: 'center', x: 3.16, y: 3.51, w: 2.87, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Sources of Mentions', options: { valign: 'center', align: 'center', x: 0.49, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.54, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Geographical Breakdown', options: { valign: 'center', align: 'center', x: 2.54, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 5.1, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Word\nCloud', options: { valign: 'center', align: 'center', x: 5.1, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 7.22, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Associated Hashtags', options: { valign: 'center', align: 'center', x: 7.22, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 10.19, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Influencers', options: { valign: 'center', align: 'center', x: 0.49, y: 10.19, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 2.02, y: 10.03, w: 7.0, h: 0.95, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'image': { x: 0.28, y: 13.37, w: 0.63, h: 0.35, path: '/static/mirum-logo.png' } },
          { 'image': { x: 1.04, y: 13.49, w: 1.27, h: 0.19, path: '/static/hks-logo.png' } },
          { 'text': { text: 'Strictly Confidential   |   ' + slideNumber++, options: { align: 'left', x: 7.50, y: 13.22, w: 2, h: 0.39, color: '666666', bold: false, fontFace: 'Proxima Nova', fontSize: 7, valign: 'middle' } } }
        ]
      })

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_NEOM_OVERVIEW',
        bkgd: 'FFFFFF',
        objects: [
          { 'rect': { x: 0.0, y: 0, w: '100%', h: 0.83, fill: 'efefef' } },
          { 'image': { x: 0.06, y: 0.06, w: 0.98, h: 0.43, path: '/static/neom-small.png' } },
          { 'text': { text: 'NEOM\'S CONVERSATION', options: { valign: 'center', align: 'center', x: -0.01, y: 0, w: 9.5, h: 0.83, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: this.months[fromMonth] + ' ' + from + ' - ' + this.months[toMonth] + ' ' + to + '\n' + toYear, options: { valign: 'center', align: 'center', x: 7.58, y: 0.0, w: 1.4, h: 0.5, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 0.28, y: 0.71, w: 8.49, h: 0.62, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'rect': { x: 3.74, y: 1.76, w: 1.7, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Summary Metrics', options: { valign: 'center', align: 'center', x: 3.74, y: 1.76, w: 1.7, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.neomCounters._tweet_count) + '\nMentions', options: { valign: 'center', align: 'center', x: 2.16, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.neomCounters._impression_count) + '\nPotential Impressions', options: { valign: 'center', align: 'center', x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 2 * 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.neomCounters._user_count) + '\nAuthors', options: { valign: 'center', align: 'center', x: 2.16 + 2 * 1.65, y: 2.48, w: 1.5, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 3.16, y: 3.51, w: 2.87, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Timeline of Mentions and Impressions', options: { valign: 'center', align: 'center', x: 3.16, y: 3.51, w: 2.87, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Sources of Mentions', options: { valign: 'center', align: 'center', x: 0.49, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.54, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Geographical Breakdown', options: { valign: 'center', align: 'center', x: 2.54, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 5.1, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Word\nCloud', options: { valign: 'center', align: 'center', x: 5.1, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 7.22, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Associated Hashtags', options: { valign: 'center', align: 'center', x: 7.22, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 10.19, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Influencers', options: { valign: 'center', align: 'center', x: 0.49, y: 10.19, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 2.02, y: 10.03, w: 7.0, h: 0.95, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'image': { x: 0.28, y: 13.37, w: 0.63, h: 0.35, path: '/static/mirum-logo.png' } },
          { 'image': { x: 1.04, y: 13.49, w: 1.27, h: 0.19, path: '/static/hks-logo.png' } },
          { 'text': { text: 'Strictly Confidential   |   ' + slideNumber++, options: { align: 'left', x: 7.50, y: 13.22, w: 2, h: 0.39, color: '666666', bold: false, fontFace: 'Proxima Nova', fontSize: 7, valign: 'middle' } } }
        ]
      })

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_QIDDIYA_OVERVIEW',
        bkgd: 'FFFFFF',
        objects: [
          { 'rect': { x: 0.0, y: 0, w: '100%', h: 0.83, fill: 'efefef' } },
          { 'image': { x: 0.08, y: 0.08, w: 0.59, h: 0.43, path: '/static/qiddiya-small.png' } },
          { 'text': { text: 'QIDDIYA\'S CONVERSATION', options: { valign: 'center', align: 'center', x: -0.01, y: 0, w: 9.5, h: 0.83, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: this.months[fromMonth] + ' ' + from + ' - ' + this.months[toMonth] + ' ' + to + '\n' + toYear, options: { valign: 'center', align: 'center', x: 7.58, y: 0.0, w: 1.4, h: 0.5, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 0.28, y: 0.71, w: 8.49, h: 0.62, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'rect': { x: 3.74, y: 1.76, w: 1.7, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Summary Metrics', options: { valign: 'center', align: 'center', x: 3.74, y: 1.76, w: 1.7, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.qiddiyaCounters._tweet_count) + '\nMentions', options: { valign: 'center', align: 'center', x: 2.16, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.qiddiyaCounters._impression_count) + '\nPotential Impressions', options: { valign: 'center', align: 'center', x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 2 * 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.qiddiyaCounters._user_count) + '\nAuthors', options: { valign: 'center', align: 'center', x: 2.16 + 2 * 1.65, y: 2.48, w: 1.5, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 3.16, y: 3.51, w: 2.87, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Timeline of Mentions and Impressions', options: { valign: 'center', align: 'center', x: 3.16, y: 3.51, w: 2.87, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Sources of Mentions', options: { valign: 'center', align: 'center', x: 0.49, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.54, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Geographical Breakdown', options: { valign: 'center', align: 'center', x: 2.54, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 5.1, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Word\nCloud', options: { valign: 'center', align: 'center', x: 5.1, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 7.22, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Associated Hashtags', options: { valign: 'center', align: 'center', x: 7.22, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 10.19, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Influencers', options: { valign: 'center', align: 'center', x: 0.49, y: 10.19, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 2.02, y: 10.03, w: 7.0, h: 0.95, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'image': { x: 0.28, y: 13.37, w: 0.63, h: 0.35, path: '/static/mirum-logo.png' } },
          { 'image': { x: 1.04, y: 13.49, w: 1.27, h: 0.19, path: '/static/hks-logo.png' } },
          { 'text': { text: 'Strictly Confidential   |   ' + slideNumber++, options: { align: 'left', x: 7.50, y: 13.22, w: 2, h: 0.39, color: '666666', bold: false, fontFace: 'Proxima Nova', fontSize: 7, valign: 'middle' } } }
        ]
      })

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_THEREDSEAPROJECT_OVERVIEW',
        bkgd: 'FFFFFF',
        objects: [
          { 'rect': { x: 0.0, y: 0, w: '100%', h: 0.83, fill: 'efefef' } },
          { 'image': { x: 0.02, y: 0.02, w: 0.64, h: 0.46, path: '/static/red-sea-small.png' } },
          { 'text': { text: 'THE RED SEA PROJECT CONVERSATION', options: { valign: 'center', align: 'center', x: -0.01, y: 0, w: 9.5, h: 0.83, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: this.months[fromMonth] + ' ' + from + ' - ' + this.months[toMonth] + ' ' + to + '\n' + toYear, options: { valign: 'center', align: 'center', x: 7.58, y: 0.0, w: 1.4, h: 0.5, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 0.28, y: 0.71, w: 8.49, h: 0.62, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'rect': { x: 3.74, y: 1.76, w: 1.7, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Summary Metrics', options: { valign: 'center', align: 'center', x: 3.74, y: 1.76, w: 1.7, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.redSeaCounters._tweet_count) + '\nMentions', options: { valign: 'center', align: 'center', x: 2.16, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.redSeaCounters._impression_count) + '\nPotential Impressions', options: { valign: 'center', align: 'center', x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 2 * 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.redSeaCounters._user_count) + '\nAuthors', options: { valign: 'center', align: 'center', x: 2.16 + 2 * 1.65, y: 2.48, w: 1.5, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 3.16, y: 3.51, w: 2.87, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Timeline of Mentions and Impressions', options: { valign: 'center', align: 'center', x: 3.16, y: 3.51, w: 2.87, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Sources of Mentions', options: { valign: 'center', align: 'center', x: 0.49, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.54, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Geographical Breakdown', options: { valign: 'center', align: 'center', x: 2.54, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 5.1, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Word\nCloud', options: { valign: 'center', align: 'center', x: 5.1, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 7.22, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Associated Hashtags', options: { valign: 'center', align: 'center', x: 7.22, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 10.19, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Influencers', options: { valign: 'center', align: 'center', x: 0.49, y: 10.19, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 2.02, y: 10.03, w: 7.0, h: 0.95, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'image': { x: 0.28, y: 13.37, w: 0.63, h: 0.35, path: '/static/mirum-logo.png' } },
          { 'image': { x: 1.04, y: 13.49, w: 1.27, h: 0.19, path: '/static/hks-logo.png' } },
          { 'text': { text: 'Strictly Confidential   |   ' + slideNumber++, options: { align: 'left', x: 7.50, y: 13.22, w: 2, h: 0.39, color: '666666', bold: false, fontFace: 'Proxima Nova', fontSize: 7, valign: 'middle' } } }
        ]
      })

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_WIW_OVERVIEW',
        bkgd: 'FFFFFF',
        objects: [
          { 'rect': { x: 0.0, y: 0, w: '100%', h: 0.83, fill: 'efefef' } },
          { 'text': { text: '#WHEREINTHEWORLD CONVERSATION', options: { valign: 'center', align: 'center', x: -0.01, y: 0, w: 9.5, h: 0.83, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: this.months[fromMonth] + ' ' + from + ' - ' + this.months[toMonth] + ' ' + to + '\n' + toYear, options: { valign: 'center', align: 'center', x: 7.58, y: 0.0, w: 1.4, h: 0.5, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 0.28, y: 0.71, w: 8.49, h: 0.62, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'rect': { x: 3.74, y: 1.76, w: 1.7, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Summary Metrics', options: { valign: 'center', align: 'center', x: 3.74, y: 1.76, w: 1.7, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.wiwCounters._tweet_count) + '\nMentions', options: { valign: 'center', align: 'center', x: 2.16, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.wiwCounters._impression_count) + '\nPotential Impressions', options: { valign: 'center', align: 'center', x: 2.16 + 1.65, y: 2.48, w: 1.6, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.16 + 2 * 1.65, y: 2.48, w: 1.6, h: 0.75, fill: '7accff' } },
          { 'text': { text: this.formatNumber(this.wiwCounters._user_count) + '\nAuthors', options: { valign: 'center', align: 'center', x: 2.16 + 2 * 1.65, y: 2.48, w: 1.5, h: 0.75, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 3.16, y: 3.51, w: 2.87, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Timeline of Mentions and Impressions', options: { valign: 'center', align: 'center', x: 3.16, y: 3.51, w: 2.87, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Sources of Mentions', options: { valign: 'center', align: 'center', x: 0.49, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 2.54, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Geographical Breakdown', options: { valign: 'center', align: 'center', x: 2.54, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 5.1, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Word\nCloud', options: { valign: 'center', align: 'center', x: 5.1, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 7.22, y: 7.22, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Associated Hashtags', options: { valign: 'center', align: 'center', x: 7.22, y: 7.22, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'rect': { x: 0.49, y: 10.19, w: 1.45, h: 0.58, fill: 'fff2cc' } },
          { 'text': { text: 'Influencers', options: { valign: 'center', align: 'center', x: 0.49, y: 10.19, w: 1.45, h: 0.58, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 11 } } },
          { 'text': { text: 'Description goes here...', options: { x: 2.02, y: 10.03, w: 7.0, h: 0.95, color: '006a56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'image': { x: 0.28, y: 13.37, w: 0.63, h: 0.35, path: '/static/mirum-logo.png' } },
          { 'image': { x: 1.04, y: 13.49, w: 1.27, h: 0.19, path: '/static/hks-logo.png' } },
          { 'text': { text: 'Strictly Confidential   |   ' + slideNumber++, options: { align: 'left', x: 7.50, y: 13.22, w: 2, h: 0.39, color: '666666', bold: false, fontFace: 'Proxima Nova', fontSize: 7, valign: 'middle' } } }
        ]
      })

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_CONCLUSTION',
        bkgd: 'FFFFFF',
        objects: [
          { 'image': { x: 0.68, y: 4.63, w: 7.55, h: 2.76, path: '/static/amaala-background.png' } },
          { 'image': { x: 0.87, y: 7.93, w: 2.77, h: 1.55, path: '/static/mirum-big.png' } },
          { 'image': { x: 3.98, y: 8.49, w: 4.34, h: 0.63, path: '/static/hks-big.png' } }
        ]
      })

      this.slide = this.pptx.addNewSlide('MASTER_SLIDE_COVER')
      this.slide = this.pptx.addNewSlide('MASTER_SLIDE_MENU')
      this.slide = this.pptx.addNewSlide('MASTER_SLIDE_AMAALA_OVERVIEW')
      this.generateTwoAxisChart(this.slide, this.amaalaCounters)
      this.generateSourcesPieChart(this.slide, this.amaalaCounters)
      this.generateGeoTable(this.slide, this.amaalaCounters)
      this.generateHashtagsTable(this.slide, this.amaalaCounters)
      this.generateWordCloudTable(this.slide, this.amaalaCounters)
      this.generateTwitterUsersTable(this.slide, this.amaalaTwitterUsers)

      this.slide = this.pptx.addNewSlide('MASTER_SLIDE_NEOM_OVERVIEW')
      this.generateTwoAxisChart(this.slide, this.neomCounters)
      this.generateSourcesPieChart(this.slide, this.neomCounters)
      this.generateGeoTable(this.slide, this.neomCounters)
      this.generateHashtagsTable(this.slide, this.neomCounters)
      this.generateWordCloudTable(this.slide, this.neomCounters)
      this.generateTwitterUsersTable(this.slide, this.neomTwitterUsers)

      this.slide = this.pptx.addNewSlide('MASTER_SLIDE_QIDDIYA_OVERVIEW')
      this.generateTwoAxisChart(this.slide, this.qiddiyaCounters)
      this.generateSourcesPieChart(this.slide, this.qiddiyaCounters)
      this.generateGeoTable(this.slide, this.qiddiyaCounters)
      this.generateHashtagsTable(this.slide, this.qiddiyaCounters)
      this.generateWordCloudTable(this.slide, this.qiddiyaCounters)
      this.generateTwitterUsersTable(this.slide, this.qiddiyaTwitterUsers)

      this.slide = this.pptx.addNewSlide('MASTER_SLIDE_THEREDSEAPROJECT_OVERVIEW')
      this.generateTwoAxisChart(this.slide, this.redSeaCounters)
      this.generateSourcesPieChart(this.slide, this.redSeaCounters)
      this.generateGeoTable(this.slide, this.redSeaCounters)
      this.generateHashtagsTable(this.slide, this.redSeaCounters)
      this.generateWordCloudTable(this.slide, this.qiddiyaCounters)
      this.generateTwitterUsersTable(this.slide, this.qiddiyaCounters)

      this.slide = this.pptx.addNewSlide('MASTER_SLIDE_WIW_OVERVIEW')
      this.generateTwoAxisChart(this.slide, this.wiwCounters)
      this.generateSourcesPieChart(this.slide, this.wiwCounters)
      this.generateGeoTable(this.slide, this.wiwCounters)
      this.generateHashtagsTable(this.slide, this.wiwCounters)
      this.generateWordCloudTable(this.slide, this.wiwCounters)
      this.generateTwitterUsersTable(this.slide, this.wiwTwitterUsers)

      this.slide = this.pptx.addNewSlide('MASTER_SLIDE_CONCLUSTION')

      this.pptx.save('Sample Presentation')
      this.exportLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customReports/AmaalaWeeklyReport.vue